export default __webpack_public_path__ + "c0b89f16aac983ad5d7095b789c61270.svg";